import React, { useState } from 'react';
import { documents } from '../../utils/api';

const DocumentBulkActions = ({
  selectedDocuments,
  setSelectedDocuments,
  onUpdate,
  documentList
}) => {
  const [showDeleteWarning, setShowDeleteWarning] = useState(false);
  const [error, setError] = useState(null);

  const handleSelectAll = () => {
    if (selectedDocuments.size === documentList.length) {
      setSelectedDocuments(new Set());
    } else {
      setSelectedDocuments(new Set(documentList.map(doc => doc.id)));
    }
  };

  const handleBulkDelete = async () => {
    try {
      await documents.bulkDelete(Array.from(selectedDocuments));
      onUpdate();
      setSelectedDocuments(new Set());
      setShowDeleteWarning(false);
    } catch (err) {
      console.error('Failed to delete documents:', err);
      setError(err.response?.data?.details || 'Failed to delete documents. Please try again later.');
    }
  };

  if (selectedDocuments.size === 0) return null;

  return (
    <>
      <div className="fixed bottom-3 inset-x-0 z-50">
        <div className="flex justify-center">
          <div style={{ 
            backgroundColor: '#FFFFFF', 
            background: 'linear-gradient(rgba(79, 69, 225, 0.03), rgba(79, 69, 225, 0.03)), #FFFFFF',
            border: '1px solid rgba(79, 69, 225, 0.1)'
          }} className="rounded-lg shadow-xl mx-4">
            <div className="p-3 flex items-center gap-2 overflow-x-auto">
              <div className="flex items-center gap-1.5 flex-nowrap">
                <button
                  onClick={handleSelectAll}
                  className="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 whitespace-nowrap"
                >
                  Select All
                </button>
                <button
                  onClick={() => setSelectedDocuments(new Set())}
                  className="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-gray-600 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 whitespace-nowrap"
                >
                  Deselect
                </button>
                <button
                  onClick={() => setShowDeleteWarning(true)}
                  className="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 whitespace-nowrap"
                >
                  Delete Selected
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Delete Warning Modal */}
      {showDeleteWarning && (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg p-6 max-w-sm w-full">
            <h3 className="text-lg font-medium text-gray-900 mb-4">Confirm Deletion</h3>
            <p className="text-sm text-gray-500 mb-4">
              Are you sure you want to delete {selectedDocuments.size} selected document{selectedDocuments.size !== 1 ? 's' : ''}? This action cannot be undone.
            </p>
            <div className="flex justify-end gap-4">
              <button
                onClick={() => setShowDeleteWarning(false)}
                className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                Cancel
              </button>
              <button
                onClick={handleBulkDelete}
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Error Display */}
      {error && (
        <div className="fixed bottom-4 right-4 bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded z-50">
          <span className="block sm:inline">{error}</span>
          <button
            onClick={() => setError(null)}
            className="absolute top-0 bottom-0 right-0 px-4 py-3"
          >
            <svg className="fill-current h-6 w-6 text-red-500" role="button" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
              <title>Close</title>
              <path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z"/>
            </svg>
          </button>
        </div>
      )}
    </>
  );
};

export default DocumentBulkActions;
